import { HttpHelper } from '../common/helpers/http-helper';

export class CommunityStatisticsApi {
    static async fetchCommunityStatistics(baseurl, token, params, abortController = null) {
        const url = `${baseurl}/communities-statistics`;

        const headers = {
            "Access-Control-Allow-Origin": "*",
            "Authorization": token
        }

        return HttpHelper.getJson(url, params, headers, abortController);
    }
}